import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { OperationsView } from './BotOpsPage';
import { BotOpsLayout } from './BotOpsData';
import BotPage from './bot-page/BotPage';
import ActivityPage from './pages/ActivityPage';
import ScorecardPage from './pages/ScorecardPage';
import AuditPage from './pages/AuditPage';

/**
 * Everything under /dashboard/bot-ops. The guard in App.tsx is the UI half; the
 * server enforces `bot_operations` on every call. One layout (one snapshot
 * poller) wraps the pages, so moving between them does not refetch.
 */
export default function BotOpsRoutes() {
  return (
    <Routes>
      <Route element={<BotOpsLayout />}>
        <Route index element={<OperationsView />} />
        <Route path="bots/:slug" element={<BotPage />} />
        <Route path="activity" element={<ActivityPage />} />
        <Route path="scorecard" element={<ScorecardPage />} />
        <Route path="audit" element={<AuditPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard/bot-ops" replace />} />
    </Routes>
  );
}
